import React from 'react'
import {Container} from 'reactstrap'
import './News.scss'

function News() {
  return (
    <Container className="News pb-5">
      <h1 className="h1 text-center mb-4">Latest news</h1>
      <p className="h4 text-center mb-5">
        I will be signing books at <strong>Books By The Bay</strong>, in historic downtown Pensacola on March 29, 2025. Stop by and we’ll
        chat all things history and books!
      </p>
    </Container>
  )
}

export default News
